import axios from "axios";
import WriteToLog from "./WriteToLog";
import getObservationFlowsheet from "./getObservationFlowsheet";
import getObservationRespDeviceFlowsheet from "./getObservationRespDeviceFlowsheet";
import getObservationVitals from "./getObservationVitals";
import getObservationVitalsByCode from "./getObservationVitalsByCode";
import getConditionProblems from "./getConditionProblems";
import getMedicationAdministrationHistory from "./getMedicationAdministrationHistory";

/**
 * Build patient object with patient details and encounter details
 * @param {*} accessTokenResponse 
 * @returns
 */
async function getRiskFactor(patFHIRID, csn, mrn, fhir_server, access_token) {
  try {
    var riskfactor = {};
    //riskfactor.patFHIRID = patFHIRID;
    riskfactor.MRN = mrn;
    riskfactor.CSN = csn;
    const ehrconfig = await axios.get('ehrconfig.json');
    let config = ehrconfig.data[fhir_server];
    riskfactor.EHR_BLOOD_GAS_LACTATE_LOINC_CODES = ehrconfig.data["EHR_BLOOD_GAS_LACTATE_LOINC_CODES"];
    riskfactor.EHR_BLOOD_GAS_BASE_EXCESS_LOINC_CODES = ehrconfig.data["EHR_BLOOD_GAS_BASE_EXCESS_LOINC_CODES"];
    const EHR_LAB_LOINC_CODES = ehrconfig.data["EHR_LAB_LOINC_CODES"];
    const EHR_MAP_ART_CUFF_FLOWSHEET = config.EHR_MAP_ART_FLOWSHEET + "," + config.EHR_MAP_CUFF_FLOWSHEET;

    const promisesArray = [getObservationVitals(patFHIRID, fhir_server, access_token),
                           getConditionProblems(patFHIRID, fhir_server, access_token),
                           getMedicationAdministrationHistory(patFHIRID, csn, fhir_server, access_token),
                           getObservationRespDeviceFlowsheet(patFHIRID, config.EHR_RESPIRATORY_DEVICE, "Respiratory Device", fhir_server, access_token),
                           getObservationRespDeviceFlowsheet(patFHIRID, config.EHR_RESPIRATORY_DEVICE_HFNC, "Respiratory Device HFNC", fhir_server, access_token),
                           getObservationFlowsheet(patFHIRID, EHR_LAB_LOINC_CODES, "Labs", fhir_server, access_token),
                           getObservationVitalsByCode(patFHIRID, EHR_MAP_ART_CUFF_FLOWSHEET, fhir_server, access_token)];

    const results = await Promise.allSettled(promisesArray);
    // results is an array of:
    // {status: "fulfilled", value: {"Systolic blood pressure":{value:129,unit:"mm[Hg]",timestamp:'2025-04-08T17:01:10Z'},"Diastolic blood pressure":{value:45,unit:"mm[Hg]",timestamp:'2025-04-08T17:01:10Z'},Pulse":{value:120,unit:"/min",timestamp:'2025-04-08T17:01:10Z'},"SpO2":{value:98,unit:"%",timestamp:'2025-04-08T17:01:10Z'},"Temp":{value:34,unit:"Cel",timestamp:'2025-04-08T17:01:10Z'},"Weight":{value:85,unit:"kg",timestamp:'2025-04-08T17:01:10Z'}}
    // {status: "fulfilled", value: {DifficultAirway:"yes", Conditions: Array(11) ['XXX.XX', 'XXX.X',...]}}
    // {status: "fulfilled", value: {MedAdministered: Array(1) {ORDER ID: 'Med Name', AdministrationInstant: '2025-04-08T15:00:00Z'},Orders: Array(1) Patient JSON}}
    // {status: "fulfilled", value: {Respiratory Device: 'High flow nasal cannula', FlowRate: {value: 5, unit: 'Lpm', timestamp: '2025-04-08T17:01:10Z'}}}
    // {status: "fulfilled", value: {Labs: {"1925-7":{"description":"Base excess in Arterial blood by calculation","value":-2.8,"unit":"mmol/L","timestamp":"2023-11-11T18:59:32Z"},"2019-8":{"description":"Carbon dioxide [Partial pressure] in Arterial blood","value":34.3,"unit":"mmHg","timestamp":"2023-11-11T18:59:32Z"},"1927-3":{"description":"Base excess in Venous blood by calculation","value":6.9,"unit":"mmol/L","timestamp":"2025-02-13T06:14:39Z"},"2021-4":{"description":"Carbon dioxide [Partial pressure] in Venous blood","value":39.1,"unit":"mmHg","timestamp":"2025-02-13T06:14:39Z"},"2518-9":{"description":"Lactate [Moles/volume] in Arterial blood","value":0.7,"unit":"mmol/L","timestamp":"2023-11-11T18:59:32Z"},"2519-7":{"description":"Lactate [Moles/volume] in Venous blood","value":1.4,"unit":"mmol/L","timestamp":"2025-02-13T06:14:39Z"},"2703-7":{"description":"Oxygen [Partial pressure] in Arterial blood","value":63.4,"unit":"mmHg","timestamp":"2023-11-11T18:59:32Z"},"2744-1":{"description":"pH of Arterial blood","value":7.41,"timestamp":"2023-11-11T18:59:32Z"},"2746-6":{"description":"pH of Venous blood","value":7.508,"timestamp":"2025-02-13T06:14:39Z"}} }}
    // {status: "ful", value: {Cuff MAP (mmHg): {value: 85, unit: , timestamp: '2025-04-08T17:01:10Z'}, Arterial (Port 1) MAP mmHg: {…}}}
    //console.log(results);
    
    for (let i=0; i < results.length; i++) {
      if (results[i].status === "fulfilled" && (results[i].value !== "Resource request returns no results." || results[i].value !== undefined)) {
        if(results[i].value) {
          if (results[i].value.Pulse) {
            riskfactor.HeartRate = results[i].value.Pulse;
          }
          if (results[i].value.SpO2) {
            riskfactor.SpO2 = results[i].value.SpO2;
          }
          if (results[i].value.Temp) {
            riskfactor.Temp = results[i].value.Temp;
          }
          if (results[i].value["Systolic blood pressure"]) {
            riskfactor.BP = results[i].value["Systolic blood pressure"];
          }
          if (results[i].value["Diastolic blood pressure"]) {
            riskfactor.Diastolic = results[i].value["Diastolic blood pressure"];
          }
          if (results[i].value.Weight && results[i].value.Weight !== "Resource request returns no results.") {
            riskfactor.Weight = results[i].value.Weight;
          }
          if(results[i].value.DifficultAirway) {
            riskfactor.DifficultAirway = results[i].value.DifficultAirway;
          } 
          if(results[i].value.CSpineInjury) {
            riskfactor.CSpineInjury = results[i].value.CSpineInjury;
          }
          if(results[i].value.CSpineInstability) {
            riskfactor.CSpineInstability = results[i].value.CSpineInstability;
          } 
          if(results[i].value.Conditions) {
            riskfactor.Conditions = results[i].value.Conditions;
          }
          if(results[i].value.MedsAdministered) {
            riskfactor.MedsAdministered = results[i].value.MedsAdministered;
          }
          if(results[i].value.Orders) {
            riskfactor.Orders = results[i].value.Orders;
          }
          if (results[i].value.BiPAP) {
            riskfactor.BiPAP = results[i].value.BiPAP;
          }
          if (results[i].value.BiPAPSet) {
            riskfactor.BiPAPSet = results[i].value.BiPAPSet;
          }
          if (results[i].value.FiO2) {
            riskfactor.FiO2 = results[i].value.FiO2;
          }
          if (results[i].value.CPAP) {
            riskfactor.CPAP = results[i].value.CPAP;
          }
          if (results[i].value.CPAPSet) {
            riskfactor.CPAPSet = results[i].value.CPAPSet;
          }
          if (results[i].value["Respiratory Device"]) {
            riskfactor.RespDevice = results[i].value["Respiratory Device"];
          }
          if (results[i].value.FlowRate) {
            riskfactor.FlowRate = results[i].value.FlowRate;
          }
          if (results[i].value["Labs"]) {
            riskfactor.labs = results[i].value["Labs"];
          }
          if (results[i].value["MAP"]) {
            riskfactor.cuff = results[i].value["MAP"];
          }
          if (results[i].value["Arterial Line MAP"]) {
            riskfactor.art = results[i].value["Arterial Line MAP"];
          }
          
        }
      }
    }
    return riskfactor;
  } catch (err) {
    WriteToLog("getRiskFactor error: " + err);
    return null;
  }
}

export default getRiskFactor;
